import { Redirect, Route, Switch } from 'wouter';

import NavigateMessageHandler from '@/ui/components/navigate-message-handler';
import ProtectedRoute from '@/ui/components/protected-route/protected-route';
import SearchParamRedirect from '@/ui/components/search-param-redirect/index.js';
import AppsPage from '@/ui/pages/apps';
import BlinkPage from '@/ui/pages/blink';
import BuyPage from '@/ui/pages/buy';
import CollectibleDetailPage from '@/ui/pages/collectible-detail';
import CollectibleSendPage from '@/ui/pages/collectible-send/index.js';
import CollectiblePage from '@/ui/pages/collectibles';
import HistoryPage from '@/ui/pages/history';
import ManageTokensPage from '@/ui/pages/manage-tokens';
import MyPasskeyPage from '@/ui/pages/my-passkey';
import SettingsPage from '@/ui/pages/settings';
import SwapPage from '@/ui/pages/swap';
import TokenDetailPage from '@/ui/pages/token-detail';
import TokenReceivePage from '@/ui/pages/token-receive';
import TokenSendPage from '@/ui/pages/token-send';
import TokensPage from '@/ui/pages/tokens';
import TransactionDetailPage from '@/ui/pages/transaction-detail';
import AppearancePage from './pages/appearance/index.js';

function Routes() {
  return (
    <>
      {!__STANDALONE_MODE__ && <NavigateMessageHandler />}

      <Switch>
        <Route path="/">
          {/** Protection is handled by the target route. */}
          {/** The last redirect takes precedence. */}
          <Redirect to="/tokens" replace />
          {__STANDALONE_MODE__ && <SearchParamRedirect />}
        </Route>
        <Route path="/tokens">
          <ProtectedRoute>
            <TokensPage />
          </ProtectedRoute>
        </Route>
        <Route path="/tokens/:token">
          <ProtectedRoute>
            <TokenDetailPage />
          </ProtectedRoute>
        </Route>
        <Route path="/tokens/:token/receive">
          <ProtectedRoute>
            <TokenReceivePage />
          </ProtectedRoute>
        </Route>
        <Route path="/tokens/:token/send">
          <ProtectedRoute>
            <TokenSendPage />
          </ProtectedRoute>
        </Route>
        <Route path="/transactions/:id">
          <ProtectedRoute>
            <TransactionDetailPage />
          </ProtectedRoute>
        </Route>
        <Route path="/collectibles">
          <ProtectedRoute>
            <CollectiblePage />
          </ProtectedRoute>
        </Route>
        <Route path="/collectibles/:id">
          <ProtectedRoute>
            <CollectibleDetailPage />
          </ProtectedRoute>
        </Route>
        <Route path="/collectibles/:id/send">
          <ProtectedRoute>
            <CollectibleSendPage />
          </ProtectedRoute>
        </Route>
        <Route path="/my-passkey">
          <ProtectedRoute>
            <MyPasskeyPage />
          </ProtectedRoute>
        </Route>
        <Route path="/my-passkey/tokens">
          <ProtectedRoute>
            <ManageTokensPage />
          </ProtectedRoute>
        </Route>
        <Route path="/my-passkey/history">
          <ProtectedRoute>
            <HistoryPage />
          </ProtectedRoute>
        </Route>
        <Route path="/my-passkey/settings">
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        </Route>
        {__STANDALONE_MODE__ && (
          <Route path="/my-passkey/settings/appearance">
            <ProtectedRoute>
              <AppearancePage />
            </ProtectedRoute>
          </Route>
        )}
        <Route path="/buy">
          <ProtectedRoute>
            <BuyPage />
          </ProtectedRoute>
        </Route>
        <Route path="/swap">
          <ProtectedRoute>
            <SwapPage />
          </ProtectedRoute>
        </Route>
        {__STANDALONE_MODE__ && (
          <Route path="/apps">
            <ProtectedRoute>
              <AppsPage />
            </ProtectedRoute>
          </Route>
        )}
        {__STANDALONE_MODE__ && (
          <Route path="/apps/blink">
            {/** Also a protected route with its own connection flow inside the page. */}
            <BlinkPage />
          </Route>
        )}
      </Switch>
    </>
  );
}

export default Routes;
